<template>
  <div class="grid grid-rows-[auto_1fr]">
    <ThreadsNav show-back>
      <template #center>Game Demo List</template>
    </ThreadsNav>
    <div class="prose">
      <ul>
        <li>
          <RouterLink to="/game-demo/beauty-and-the-beast" target="_blank">
            Beauty and The Beast
          </RouterLink>
          (2024-11-27)
        </li>
        <li>
          <RouterLink to="/game-demo/school-days" target="_blank">
            School Days
          </RouterLink>
          (2024-12-30)
        </li>
      </ul>
    </div>
  </div>
</template>
